"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {
            display: 'flex',
            alignItems: 'center',
        },
        cardContent: {
            padding: '10px',
            '&:hover': {
                cursor: 'pointer',
            },
            '&:last-child': {
                paddingBottom: '10px',
            }
        },
    });
});
